import Button from '@material-ui/core/Button';
import compose from 'recompose/compose';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import React from 'react';
import { actions as dialogActions } from 'redux/domain/Dialog';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { withTheme } from '@material-ui/core/styles';

// This is the first attempt at a somewhat reusable Dialog Box
class DialogContainer extends React.Component {
	constructor() {
		super();

		this.handleClose = this.handleClose.bind(this);
	}

	// show the dialog on load
	componentDidMount() {
		const { showDialog } = this.props;
		showDialog();
	}

	// Close the dialog window and then call the caller's specified callback
	handleClose() {
		const { closeDialog, onClose } = this.props;
		closeDialog();
		// passed in call back
		onClose();
	}

	render() {
		const { theme } = this.props;
		const { buttonLabel, message, isDialogVisible } = this.props;

		return (
			<Dialog open={isDialogVisible} onClose={this.handleClose}>
				<DialogContent>
					<DialogContentText style={{ fontSize: '1.1em' }}>{message}</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button
						style={{
							backgroundColor: theme.palette.secondary.main,
							color: theme.palette.getContrastText(theme.palette.secondary.main),
						}}
						onClick={this.handleClose}
					>
						{buttonLabel}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}

DialogContainer.propTypes = {
	message: PropTypes.string.isRequired,
	isDialogVisible: PropTypes.bool.isRequired,
	showDialog: PropTypes.func.isRequired,
	closeDialog: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired,
	buttonLabel: PropTypes.string.isRequired,
	theme: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = state => {
	const isDialogVisible = state.dialog.get('isDialogVisible');
	return {
		isDialogVisible,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators(dialogActions, dispatch);

// for testing purposes
export { DialogContainer as DialogContainerClass };

// connect returns a function that accepts a component
export default compose(connect(mapStateToProps, mapDispatchToProps), withTheme)(DialogContainer);
